import { labels } from '../../organisms/search/config';

const detailTemplate = data => {
  // let openingHours = '';

  // data.openingHours.forEach(opening => {
  //   const day = Object.keys(opening)[0];
  //   const hours = opening[day];
  //   openingHours += `<dt class="schedule__day">${day}</dt><dd class="schedule__hours">${hours}</dd>`;
  // });

  const template = `
<article class="teaser-contact teaser-contact--map-detail">
  <header class="teaser-contact__header">
      ${
        data.mark || data.mk
          ? `<div class="teaser-contact__info">
            <div class="teaser-contact__meta">
            <div class="teaser-contact__type">${
              Array.isArray(data.mark || data.mk)
                ? (data.mark || data.mk).join(
                    '<span class="teaser-contact__type-separator" aria-hidden="true">|</span>'
                  )
                : data.mark || data.mk
            }</div>
          </div>
        </div>`
          : ''
      }
      ${
        data.title || data.tt
          ? `<h3 class="teaser-contact__heading">
          <span class="sr-only">Kontakt</span>${data.title || data.tt}
        </h3>`
          : ''
      }
  </header>
  <div class="teaser-contact__content">
    <div class="teaser-contact__address">
      <address class="address address--map-detail">
    ${
      data.address || data.a
        ? `<span class="address__office">
        <span class="address__text">${
          data.address?.street || data.a?.st
            ? data.address?.street || data.a?.st
            : ''
        }${
            (data.address?.street &&
              (data.address?.zip || data.address?.city)) ||
            (data.a?.st && (data.a?.zp || data.a?.ct))
              ? ', '
              : ' '
          }${
            data.address?.zip || data.a?.zp
              ? data.address?.zip || data.a?.zp
              : ''
          }${
            data.address?.street ||
            data.address?.zip ||
            data.a?.st ||
            data.a?.zp
              ? ' '
              : ''
          }${
            data.address?.city || data.a?.ct
              ? data.address?.city || data.a?.ct
              : ''
          }</span>
      </span>`
        : ''
    }
      <span class="address__contacts">
        ${
          data.phone || data.p
            ? `<span class="address__heading">Telefon:</span>
            <span class="address__text">
                <a class="styled-link styled-link--tel address__link" href="tel:${
                  data.phone || data.p
                }">${data.phone || data.p}</a>
            <span class="styled-link-replacement address__link">${
              data.phone || data.p
            }</span>
          </span>`
            : ''
        }
        ${
          (data.additionalPhones && data.additionalPhones.length) ||
          (data.pa && data.pa.length)
            ? (data.additionalPhones || data.pa)
                .map(phone => {
                  return `
                <span class="address__heading">${
                  phone.label || phone.l || ''
                }:</span>
                  <span class="address__text">
                      <a class="styled-link styled-link--tel address__link" href="tel:${
                        phone.number || phone.n || ''
                      }">${phone.number || phone.n || ''}</a>
                      <span class="styled-link-replacement address__link">${
                        phone.number || phone.n || ''
                      }</span>
                      ${phone.text || phone.t || ''}
                </span>
                `;
                })
                .join('')
            : ''
        }
        ${
          data.email || data.e
            ? `<span class="address__heading">E-Mail:</span>
            <span class="address__text">
              <a class="styled-link styled-link--mailto address__link" href="mailto:${
                data.email || data.e
              }">${data.email || data.e}</a>
            </span>
          </span>`
            : ''
        }
      </address>
    </div>
    ${
      data.addendum || data.ad
        ? `<div class="teaser-contact__info">${data.addendum || data.ad}</div>`
        : ''
    }
    ${
      data.openingHours || data.oh
        ? `<div class="accordion accordion--contact accordion--map-detail teaser-contact__schedules">
        <section class="accordion__item">
          <h4 class="accordion__heading">
            <button type="button" class="accordion__button">
            ${labels.document.openingHours}
              <span class="accordion__icon icon icon--chevron-down-thick">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-chevron-down-thick"></use>
                </svg>
                <span class="sr-only">${labels.accordion.open}</span>
              </span>
              <span class="accordion__icon icon icon--chevron-up-thick">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-chevron-up-thick"></use>
                </svg>
                <span class="sr-only">${labels.accordion.close}</span>
              </span>
            </button>
        </h4>

      <div class="accordion__content">
        <div class="accordion__content-inner">
          ${data.openingHours || data.oh}
        </div>
      </div>
    </section>
    </div>`
        : ''
    }
  </div>
  ${
    data.url || data.urlLocalAssociations || data.u || data.ua
      ? `
    <footer class="teaser-contact__footer">
      ${
        (data.url && !data.urlLocalAssociations) || (data.u && !data.ua)
          ? `
        <a class="styled-link styled-link--boxed-blue teaser-contact__footer-link click-redirect-target" href="${
          data.url || data.u
        }">
          <span class="styled-link__icon icon icon--arrow-internal">
            <svg class="icon__svg" role="img" aria-hidden="true">
              <use href="#icon-arrow-internal"></use>
            </svg>
          </span>
          ${data.linkText || data.lt}
          <span class="sr-only">
            ${data.title || data.tt}
          </span>
        </a>
        `
          : ''
      }
      ${
        (data.urlLocalAssociations && !data.url) || (data.ua && !data.u)
          ? `
        <a class="styled-link styled-link--boxed-blue teaser-contact__footer-link click-redirect-target" href="${
          data.urlLocalAssociations || data.ua
        }">
          <span class="styled-link__icon icon icon--arrow-internal">
            <svg class="icon__svg" role="img" aria-hidden="true">
              <use href="#icon-arrow-internal"></use>
            </svg>
          </span>
          ${data.linkTextLocalAssociations || data.lta}
        </a>
        `
          : ''
      }
      ${
        (data.url && data.urlLocalAssociations) || (data.u && data.ua)
          ? `
        <ul class="teaser-contact__footer-list">
          <li>
            <a class="styled-link styled-link--boxed-blue teaser-contact__footer-link click-redirect-target" href="${
              data.url || data.u
            }">
              <span class="styled-link__icon icon icon--arrow-internal">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-arrow-internal"></use>
                </svg>
              </span>
              ${data.linkText || data.lt}
              <span class="sr-only">
                ${data.title || data.tt}
              </span>
            </a>
          </li>
          <li>
            <a class="styled-link styled-link--boxed-blue teaser-contact__footer-link" href="${
              data.urlLocalAssociations || data.ua
            }">
              <span class="styled-link__icon icon icon--arrow-internal">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-arrow-internal"></use>
                </svg>
              </span>
              ${data.linkTextLocalAssociations || data.lta}
            </a>
          </li>
        </ul>
        `
          : ''
      }
    </footer>
  `
      : ''
  }
</article>`;

  return template;
};

export { detailTemplate };
